import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { decodeJwt } from "../utils/decodeJwt";
import { saveAdminDetails } from "../features/auth/authSlice";
import { getMe } from "../features/profile/profileApi";
import { Spin } from "antd";

interface ProtectedRouteProps {
  children: React.ReactNode;
  tag?: string; // Optional: Array of roles allowed to access the route
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, tag }) => {
  const dispatch = useDispatch();
  const { admin, isAuthenticated } = useSelector((state: any) => state.auth);

  // Get token from cookies
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token="))
    ?.split("=")[1];
  const decoded = token ? decodeJwt(`token=${token}`) : null;

  const [loading, setLoading] = useState(false);
  const [unauthorized, setUnauthorized] = useState(false);

  const getMyDetails = async () => {
    const response: any = await getMe(setLoading);
    if (response) {
      dispatch(
        saveAdminDetails({
          admin: response,
          isAuthenticated: true,
        })
      );
    }
  };

  useEffect(() => {
    if (!admin?.email || !admin?.fullName) {
      getMyDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!token || !decoded) {
      // No need to fetch if not authenticated
      return;
    } else if (!admin || !isAuthenticated) {
      dispatch(
        saveAdminDetails({
          admin: {
            fullName: "",
            email: "",
            permissions: decoded?.authorities || [],
            roleNames: [],
          },
          isAuthenticated: true,
        })
      );
    }

    if (tag && !decoded?.authorities?.includes(tag)) {
      setUnauthorized(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tag, token, decoded]);

  if (!token || !decoded) {
    return <Navigate to="/login" />;
  }

  if (unauthorized) {
    return <Navigate to="/unauthorized" />;
  }

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "95vh",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  // Render the protected content if all checks pass
  return <>{children}</>;
};

export default ProtectedRoute;
